module.exports = __webpack_public_path__ + "img/login_img.be3e082c.png";